import { Component } from '@opten/compiler/metadata/component';
import { Collapse } from '@opten/collapse/initializer';
import hasClass from '@opten/dom/has-class';
import addClass from '@opten/dom/add-class';
import removeClass from '@opten/dom/remove-class';

@Component({ className: 'js-collapse', observe: true })
export class CollapseComponent {
	constructor(private element: HTMLElement) {
		const collapse = new Collapse(element, {});

		if (hasClass(this.element, 'js-collapse--backdrop')) {
			this.element.addEventListener('show.opten.collapse', () => {
				addClass(this.element.parentElement, 'is-backdrop-active');
			});

			this.element.addEventListener('hide.opten.collapse', () => {
				removeClass(this.element.parentElement, 'is-backdrop-active');
			});
		}

		if (`#${element.id}` === window.location.hash) {
			collapse.toggle();
		}
	}
}
